import { css } from '@styles/theme'

export const ModalStyles = {
	modalDeleteAccount: css({
		color: '$neutral130',
		'& p': {
			paddingBottom: 30,
			fontSize: '$xl',
			fontWeight: 400,
		},
		'& span': {
			paddingBottom: 30,
			fontSize: '$xl',
			fontWeight: 400,
		},
	}),
}
